import React, { useState } from "react";
import { UI_ITOModuleTitle } from "../../UI_ITO/indexUI";
import { Button, DatePicker, Form, Select } from "antd";

import { useForm } from "antd/es/form/Form";
import classes from "./pageReports.module.css";
import dayjs from "dayjs";
import { applicationBankDocumentsApi } from "../../services/documents/documents.api";

const { downloadReport } = applicationBankDocumentsApi;

export const PageReports = () => {
  const [form] = useForm();

  const [isFormFullfilled, setIsFormFullFilled] = useState(false);

  const handleClick = () => {
    if (isFormFullfilled) {
      downloadReport({
        startDate: form.getFieldValue("start_date"),
        endDate: form.getFieldValue("end_date"),
      });
    }
  };

  const handleChangeForm = () => {
    setIsFormFullFilled(
      form.getFieldValue("start_date") && form.getFieldValue("end_date")
    );
  };

  return (
    <div className={classes.container}>
      <Form form={form} onValuesChange={handleChangeForm}>
        <UI_ITOModuleTitle title="Отчеты" />
        <h3>Сформировать отчет</h3>
        <div className={classes["report-row"]}>
          <div className={classes["report-column"]}>
            <div className={classes["input-title"]}>Тип отчета</div>
            <Select
              defaultValue="bg"
              className={classes["report-type-selector"]}
            >
              <Select.Option value="bg">Банковские гарантии</Select.Option>
            </Select>
          </div>
          <div className={classes["report-column"]}>
            <div className={classes["input-title"]}>Дата начала</div>
            <Form.Item name="start_date">
              <DatePicker allowClear={false} format={"DD.MM.YY"} />
            </Form.Item>
          </div>
          <div className={classes["report-column"]}>
            <div className={classes["input-title"]}>Дата окончания</div>
            <Form.Item name="end_date" initialValue={dayjs()}>
              <DatePicker allowClear={false} format={"DD.MM.YY"} />
            </Form.Item>
          </div>
        </div>
        <div className={classes["report-row"]}>
          <Button
            type="primary"
            className={classes["create-report-button"]}
            onClick={handleClick}
            disabled={!isFormFullfilled}
          >
            Сформировать отчет
          </Button>
        </div>
      </Form>
    </div>
  );
};
